import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './HeaderPanel';
import HeroPanel from './HeroPanel';
import BookLessonPanel from './BookLessonPanel';
import DragonsPanel from './DragonsPanel';
import YouTubePanel from './YouTubePanel';
import MerchPanel from './MerchPanel';
//import SpecialPanel from './MerchPanel';
//import SpecialPanel from './PromoPanel';
import SchoolPanel from './SchoolPanel';
import EventPanel from './EventPanel';
import FooterPanel from './FooterPanel';
import SpecialDialog from './SpecialDialog';
import Cookies from 'js-cookie';

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class WelcomePage extends React.Component {
  myRef = React.createRef();

    constructor(props) {
    super(props);

    let bShowMerch2507Dialog = false;

    if (Cookies.get("Merch2507Dialog") != 'shown') {
        bShowMerch2507Dialog = true;
        Cookies.set('Merch2507Dialog', 'shown');
    }

    this.state = {
        bShowMiniLogo: false,
        bShowMerch2507Dialog: bShowMerch2507Dialog
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    const position = window.pageYOffset;

    this.setState( {scroll: position} )

    if (position > 140 && !this.state.bShowMiniLogo) {
        this.setState( {bShowMiniLogo: true} )
    }

    if (position <= 140 && this.state.bShowMiniLogo) {
        this.setState( {bShowMiniLogo: false} )
    }
  }

  render() {
    const { classes } = this.props;

    let self = this;

      const handleClose = () => {
          self.setState( {bShowMerch2507Dialog: false} )
      };

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={self.state.bShowMiniLogo} ref={this.myRef} />
              <HeroPanel />
              <BookLessonPanel />
              <DragonsPanel />
              <YouTubePanel />
              <MerchPanel />
              <SchoolPanel />
              <EventPanel />
              <FooterPanel />

              <SpecialDialog
                  open={self.state.bShowMerch2507Dialog}
                  onClose={handleClose}
              />
          </div>
      );
  }
}

export default withStyles(useStyles)(WelcomePage)
